/* eslint-disable */
import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE_URL = "https://backend-foorweb-nevzx.ondigitalocean.app/apis";
// const API_BASE_URL = "http://localhost:2086/apis";

const workersAPI = {
  getAuthToken: () => {
    return localStorage.getItem("token");
    // return "eyJhbGciOiJSUzI1NiIsImtpZCI6ImEzOGVhNmEwNDA4YjBjYzVkYTE4OWRmYzg4ODgyZDBmMWI3ZmJmMGUiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZm9vcndlYi1kZXYiLCJhdWQiOiJmb29yd2ViLWRldiIsImF1dGhfdGltZSI6MTc2Njg0NjM1OSwidXNlcl9pZCI6ImdyWk1VT3JPbjljc01SY0xOSUtrdHFOa2N2WjIiLCJzdWIiOiJnclpNVU9yT245Y3NNUmNMTklLa3RxTmtjdloyIiwiaWF0IjoxNzY2ODQ2MzU5LCJleHAiOjE3NjY4NDk5NTksImVtYWlsIjoieml0b3VuaXJhbmlhMjUwOUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJ6aXRvdW5pcmFuaWEyNTA5QGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.ViEOQf_Wy5BdNmOvZKsAvnJyqxmJFtUuEnXkkfUZLu7f4DryfEtxIyXQVFJcxfkajljEMtwNw2Dv2Sm7biDHDAZCaVPfha4InNfeEMYF7e6cF8V8VbUzdBvE0MiUf6BDBwE-4I3CxOEwhLDxkG_U3GZM5cXIjUr5lXVdjEpLI9rZ7-4e1PxpPCLxxIGSFk_RWzRBI6r-pNbeVlPNAe25Eohx5wQzk_QVLb9Pi07iDaPAMUwl7SRQVEysKSZDlkjhKSoxNdllztIZXaYDRONCXZ2DRg4AxM1gyGHX7h3NeBG2RJVrCXKdBFQeM81y8g5gvNAcyswb_-YJVQgOtbCedg";
  },

  // Get all workers
  getAllWorkers: async () => {
    try {
      const token = workersAPI.getAuthToken();
      const response = await axios.get(`${API_BASE_URL}/workers`, {
        params: {
          user: token,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Send invitation to new worker (create worker)
  inviteWorker: async (workerData) => {
    try {
      const token = workersAPI.getAuthToken();
      const response = await axios.post(
        `${API_BASE_URL}/workers/invite`,
        workerData,
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //     "Content-Type": "application/json",
        //   },
        // },
        {
          params: {
            user: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update worker permissions
  updateWorkerPermissions: async (workerId, permissions, products) => {
    try {
      const token = workersAPI.getAuthToken();

      const response = await axios({
        method: "PUT",
        url: `${API_BASE_URL}/workers/${workerId}/permissions`,
        data: {
          permissions: permissions,
          ...(products !== undefined ? { products } : {}),
        },
        // headers: {
        //   Authorization: `Bearer ${token}`,
        //   "Content-Type": "application/json",
        // },
        params: {
          user: token,
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // delete worker
  deleteWorker: async (workerId) => {
    try {
      const token = workersAPI.getAuthToken();
      const response = await axios.delete(
        `${API_BASE_URL}/workers/${workerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            user: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default workersAPI;
